/**
 * An equivalent copy of this file exists in billing-ui, ficon-ui and
 * lightning-ui. Unless a change is app-specific, apply it there too.
 */
import type { AxiosResponse } from 'axios';

import { isBackendVersionNewer } from '@rygen/rygen-ui/applicationVersion';
import { HttpHeader } from '@rygen/rygen-ui/model';

import { useVersionStore } from '@/stores/VersionStore';
import { version as frontendVersion } from '@/version';

/**
 * if versions are empty - do nothing
 *
 * if same - do nothing
 *
 * if backend is newer - set NEEDS_REFRESH state
 *
 * if backend is older - do nothing
 */
export default (response: AxiosResponse): AxiosResponse => {
  const {
    isHardRefreshEnabled,
    requiresHardRefresh,
    setBackendVersion,
    setRequiresHardRefresh,
  } = useVersionStore();

  if (!isHardRefreshEnabled.value || !frontendVersion) {
    return response;
  }

  const backendVersion = response.headers[HttpHeader.APPLICATION_VERSION] as
    | string
    | undefined;

  if (backendVersion) {
    setBackendVersion(backendVersion);
  }

  if (!backendVersion || backendVersion === frontendVersion) {
    return response;
  }

  if (
    isBackendVersionNewer(backendVersion, frontendVersion) &&
    !requiresHardRefresh.value
  ) {
    console.warn(
      `Backend v${backendVersion} | Frontend v${frontendVersion} : Application will perform a hard refresh on next navigation`,
    );
    setRequiresHardRefresh(true);
  }

  return response;
};
